"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DateTime_1 = require("../../DateTime");
const entityTypes_1 = require("../entityTypes");
const operationTypes_1 = require("../operationTypes");
const eventColumns = () => ([
    {
        accessor: 'entityId',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/List/Column:Id', defaultMessage: 'ID' })),
        Cell: ({ row }) => {
            const id = row.original.entityId;
            return id !== null && id !== void 0 ? id : null;
        },
    },
    {
        accessor: 'timestamp',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/List/Column:Date', defaultMessage: 'Date' })),
        Cell: ({ row }) => (react_1.default.createElement(DateTime_1.Date, { value: row.original.timestamp, isLocalTime: true })),
    },
    {
        accessor: 'entityType',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/List/Column:Type', defaultMessage: 'Type' })),
        disableSortBy: true,
        Cell: ({ row }) => {
            var _a;
            const entity = row.original.entityType;
            if (!entity)
                return null;
            return (react_1.default.createElement("strong", null, (_a = entityTypes_1.entityTypes[entity]) !== null && _a !== void 0 ? _a : entity));
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/List/Column:Operation', defaultMessage: 'Operation' })),
        id: 'operationType',
        disableSortBy: true,
        Cell: ({ row }) => {
            var _a;
            const operation = row.original.operation;
            if (!operation)
                return null;
            return (_a = operationTypes_1.operationTypes[operation]) !== null && _a !== void 0 ? _a : operation;
        },
    },
    {
        id: 'user',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/List/Column:Initiator', defaultMessage: 'Initiator' })),
        disableSortBy: true,
        Cell: ({ row }) => { var _a; return (_a = row.original.userDisplayName) !== null && _a !== void 0 ? _a : null; },
    },
]);
exports.eventColumns = eventColumns;
//# sourceMappingURL=tableColumns.js.map